import { safetyGet, isSupported } from 'Src/util/tool'
const GLOBAL_VAR = window.GLOBAL_VAR
// 反垄断白名单
const isAntitrust = isSupported(GLOBAL_VAR?.adver_func?.kua_duan)
function userAntitrust (endTime = 0) {
  let antiMonopolyAgreement = safetyGet(GLOBAL_VAR, 'anti_monopoly_agreement', '{}')
  try {
    antiMonopolyAgreement = typeof antiMonopolyAgreement === 'string' ? JSON.parse(antiMonopolyAgreement) : antiMonopolyAgreement
  } catch {
    antiMonopolyAgreement = {}
  }
  // 如果在白名单里， 需要判断first_phase_timeline时间是否过期
  const nowTime = dayjs().unix()
  if (!endTime) {
    if (isAntitrust) {
      endTime = antiMonopolyAgreement?.first_phase_timeline?.end_time || 0
    } else {
      // 如果不在白名单里面，需要判断second_phase_timeline时间是否过期
      endTime = antiMonopolyAgreement?.second_phase_timeline?.end_time || 0
    }
  }
  return !!(nowTime > endTime && endTime)
}
window.userAntitrust = userAntitrust()
